import React, { useState } from "react";
import classes from "./styles/style.module.css";
import ChevronDownIcon from "../../../assets/images/icons/chevron-Down.svg";
import { FaChevronDown } from "react-icons/fa6";

const CustomSelect = ({
  label,
  value,
  disabled,
  handleChange,
  options,
  name,
  placeHolder,
  dark
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };

  const handleSelect = (selected) => {
    if (disabled) return;
    handleChange(selected);
    setOpen(false);
  };

  return (
    <>
      <label className={`${disabled ? classes.disabled : ""}`} htmlFor={name}>
        {label}
      </label>
      <div className={`${classes.selectContainer} ${dark ? classes.dark : ''} ${disabled ? classes.disabledContainer : ''}`} aria-disabled={disabled} onClick={handleOpen}>
        <p className={disabled ? classes.disabledColor : ""}>
          {value ? value : placeHolder}
        </p>
        {!disabled && (dark ? <FaChevronDown /> :
          <img src={ChevronDownIcon} alt="chevronDown" />
        )}
      </div>
      <div
        className={`${classes.dropDownMenu} ${dark ? classes.darkDropDown : ''} ${open && !disabled ? classes.open : classes.close
          }`}
      >
        {options.map((item, index) => {
          return (
            <p key={index} onClick={() => handleSelect(item)}>
              {item}
            </p>
          );
        })}
      </div>
    </>
  );
};

export default CustomSelect;
